module.exports = require("./bs.d.ts");